import { DisplayGrid, GridType, GridsterConfig, GridsterItem } from "angular-gridster2";
import { ReplaySubject } from "rxjs";

export class EliteFormDesignItemModel {
  id: string;
  fieldKey: string;
  title: string;
  length: number;
  width: number;
  isEmptyBox: boolean;
  isMandatory: boolean;
  dataType: string;
  styleClassName: string;

  constructor(id: string, title: string, length: number, gridItemCount: number, isEmptyBox = true, isMandatory = false) {
    this.id = id;
    this.length = length;
    this.width = (100 / gridItemCount) * length;
    this.isEmptyBox = isEmptyBox;
    this.title = title;
    this.isMandatory = isMandatory;
  }
}
export class DesignItemModel implements GridsterItem {
  id?: string;
  pageGroupItemId: string;
  groupId?: string;
  parentId?: string;
  fieldKey?: string;
  title?: string;
  instruction?: string;
  dataType?: string;
  isMandatory: boolean;
  styleClassName: string;
  rows: number;
  minItemRows?: number;
  cols: number;
  x: number;
  y: number;
  dragEnabled?: boolean;
  notPlaced?: boolean;
  positionChanged$?: ReplaySubject<any>;
  sizeChanged$?: ReplaySubject<any>;
  layoutChanged$?: ReplaySubject<any>;

  flowChartId: string;
  flowChartSectionId: string;
  groupOptions?: GridsterConfig;
  groupItems?: Array<DesignItemModel>;
  metaData?: any;
}


export const EliteFormOptionsConfig: GridsterConfig = {
  gridType: GridType.VerticalFixed,
  minCols: 12,
  maxCols: 12,
  minRows: 20,
  maxRows: 20,
  margin: 20,
  disableScrollHorizontal: true,
  //outerMargin: false,
  //fixedColWidth: 30,
  fixedRowHeight: 50,
  draggable: {
    enabled: true
  },
  resizable: {
    enabled: true
  },
  displayGrid: DisplayGrid.Always,
  itemChangeCallback: (item: DesignItemModel, component: any) => {
    item.layoutChanged$.next({ item, component })
  },
  itemResizeCallback: (item: DesignItemModel, component: any) => {
    //item.layoutChanged$.next({item, component})
  },
  enableBoundaryControl: true,
  disableScrollVertical: true,
  disableAutoPositionOnConflict: true,


};


export const EliteFormSubOptionsConfig: GridsterConfig = {
  enableBoundaryControl: true,
  // disableScrollVertical: true,
  gridType: GridType.VerticalFixed,
  minCols: 12,
  maxCols: 12,
  minRows: 2,
  maxRows: 2,
  // outerMargin: false,
  // outerMarginBottom: 0,
  // outerMarginTop: 0,
  margin: 20,
  disableScrollHorizontal: true,
  mobileBreakpoint: 0,
  fixedRowHeight: 50,
  draggable: {
    enabled: true
  },
  resizable: {
    enabled: true
  },
  displayGrid: DisplayGrid.Always,
  itemChangeCallback: (item: DesignItemModel, component: any) => {
    item.layoutChanged$.next({ item, component })
  },
  itemResizeCallback: (item: DesignItemModel, component: any) => {
    //item.layoutChanged$.next({item, component})
  },
};
